import store from "../store";

export const cobraConstants = {
  PERSON_TYPES: [
    { id: 1, name: 'Spouse' },
    { id: 2, name: 'Children' },
    { id: 3, name: 'Beneficiary' },
    { id: 4, name: 'Contingent' },
    { id: 5, name: 'Dependent' }
  ],
  ELECTION_EVENT_TYPES: {
    LifeEvent: 1,
    Open: 2
  },
  ELECTION_STATUSES: {
    'Open': 1,
    'Elected': 2,
    'Terminated': 3
  },
  PAYMENT_TYPES: [
    { id: 1, name: 'Check' },
    { id: 2, name: 'ACH' },
    { id: 5, name: 'Credit/Debit Card' },
  ],
  PAYMENT_STATUSES: Object.freeze({
    Applied: { name: 'Applied', id: 1 },
    Rejected: { name: 'Rejected', id: 2 },
    Voided: { name: 'Voided', id: 3 }
  }),
  INVOICE_LETTER_TYPES: [
    { name: 'None', id: 1 },
    { name: 'Premium Notice', id: 2 },
    { name: 'Coupon Book', id: 3 },
  ],
  
  COBRA_PARTICIPANT_TYPE: {
    NotEligible: 1,
    Eligible: 2,
    QB: 3,
    DependentQB: 4,
  },
  PARTICIPANT_EMPLOYEE_TYPES: [
    { name: 'Full-Time', id: 1 },
    { name: 'Part-Time', id: 2 },
    { name: 'Unknown', id: 3 },
    { name: 'Custom', id: 4 },
  ],
  PARTICIPANT_PAYROLL_TYPES: [
    { name: 'Executive', id: 1 },
    { name: 'Exempt', id: 2},
    { name: 'Hourly', id: 3 },
    { name: 'Non-Exempt', id: 4 },
    { name: 'Salary', id: 5 },
  ],
  SERVICE_TYPE: Object.freeze( {
    QB: { name: 'QB', id: 1 },
    DirectBill: { name: 'DirectBill', id: 2 },
  }),
  DEPENDENT_TYPES: [
    { name: 'Spouse', id: '1' },
    { name: 'Child', id: '2' },
    { name: 'Domestic Partner', id: '3' },
    { name: 'Unknown', id: '0' },
    { name: 'Other', id: '4' },
  ],

  COVERAGE_END_RULES: [
    { name: 'Date of Qualifying Event', id: 1 },
    { name: 'End of Month / Extended employer notice rule', id: 2},
    { name: 'Employer Notice Rule', id: 3 },
  ],
  RATE_TYPES: Object.freeze({
    Composite: { name: 'Composite (per Coverage Level)', id: 1 },
    MemberSpecific: { name: 'Member-Specific (per Individual)', id: 2 },
    Banded: { name: 'Banded (per Age, Gender, and/or Number of Children)', id: 3 }
  }),
  AGE_DETERMINED_BY: Object.freeze({
    Birthday: { name: 'Birthday', id: 1 },
    Plan: { name: 'Plan', id: 2 },
    //Banded: { name: 'Enrollment', id: 3 }
  }),
  DEMOGRAPHIC_TARGETS: Object.freeze({
    Employee: { name: 'Employee', id: 1 },
    Spouse: { name: 'Spouse', id: 2 },
    Adult: { name: 'Adult', id: 3 },
    Children: { name: 'Children', id: 4 },
  }),
  DEMOGRAPHIC_TYPES: Object.freeze({
    Age: { name: 'Age', id: 1 },
    Gender: { name: 'Gender', id: 2 },
    Number: { name: 'Number', id: 3 },
  }),
  RATE_BAND_GENDER: Object.freeze({
    Male: { name: 'Male', id: 1 },
    Female: { name: 'Female', id: 2 },
    Undisclosed: { name: 'Undisclosed', id: 3 },
  }),

  MAIL_STATUS: {
    New: 1,
    Sent: 2,
    Failed: 3,
    Cancelled: 4
  },
  POSTGRID_STATUS: {
    ReadyToPrint: "Ready to Print",
    Printing: "Printing",
    ProcessedForDelivery: "Processed for Delivery",
    Completed: "Completed",
    Cancelled: "Cancelled"
  },
  RENEWAL_MONTHS: [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' }
  ],
  
  STANDARD_COVERAGE_LEVELS: [
    {
      type: "EE Only",
      coversEmployee: true,
      personTypes: [],
      isDefault: true,
    },
    {
      type: "EE + Spouse",
      coversEmployee: true,
      personTypes: [
        { header: "Spouse", personType: 1, min: 1, max: 1 }
      ],
      isDefault: true,
    },
    {
      type: "EE + Child",
      coversEmployee: true,
      personTypes: [
        { header: "Child", personType: 2, min: 1, max: 1 }
      ],
      isDefault: true,
    },
    {
      type: "EE + Children",
      coversEmployee: true,
      personTypes: [
        { header: "Children", personType: 2, min: 2, max: 26 }
      ],
      isDefault: true,
    },
    {
      type: "EE + Family",
      coversEmployee: true,
      personTypes: [
        { header: "Spouse", personType: 1, min: 1, max: 1 },
        { header: "Child", personType: 2, min: 1, max: 26 }
      ],
      isDefault: true,
    },
    {
      type: "Spouse Only",
      coversEmployee: false,
      personTypes: [
        { header: "Spouse", personType: 1, min: 1, max: 1 },
      ],
      isDefault: false,
    },
    {
      type: "Spouse + Child",
      coversEmployee: false,
      personTypes: [
        { header: "Spouse", personType: 1, min: 1, max: 1 },
        { header: "Child", personType: 2, min: 1, max: 1 }
      ],
      isDefault: false,
    },
    {
      type: "Spouse + Children",
      coversEmployee: false,
      personTypes: [
        { header: "Spouse", personType: 1, min: 1, max: 1 },
        { header: "Child", personType: 2, min: 2, max: 26 }
      ],
      isDefault: false,
    },
    {
      type: "Child Only",
      coversEmployee: false,
      personTypes: [
        { header: "Child", personType: 2, min: 1, max: 1 },
      ],
      isDefault: false,
    },
    {
      type: "Children Only",
      coversEmployee: false,
      personTypes: [
        { header: "Child", personType: 2, min: 2, max: 26 },
      ],
      isDefault: false,
    },
    {
      type: "EE + 1",
      coversEmployee: true,
      personTypes: [
        { header: "Dependent", personType: 5, min: 1, max: 1 },
      ],
      isDefault: false,
    },
    {
      type: "EE + 2",
      coversEmployee: true,
      personTypes: [
        { header: "Dependent", personType: 5, min: 2, max: 2 },
      ],
      isDefault: false,
    },
    {
      type: "EE + 3",
      coversEmployee: true,
      personTypes: [
        { header: "Dependent", personType: 5, min: 3, max: 3 },
      ],
      isDefault: false,
    },
    {
      type: "EE + 4",
      coversEmployee: true,
      personTypes: [
        { header: "Dependent", personType: 5, min: 4, max: 4 },
      ],
      isDefault: false,
    },
  ]
}

export const cobraFunctions = {
  getPaymentTypes: (filter) => {
    var paymentTypes = [...cobraConstants.PAYMENT_TYPES];
    if(filter) paymentTypes = paymentTypes.filter(filter);
    var features = store.state.session.features;
  
    if(features && !features.includes('cobra-credit-card-payments'))
      paymentTypes = paymentTypes.filter(f => f.id != 3);
  
    return paymentTypes;
  },
  getPaymentTypeName: (id) => {
    const type = cobraConstants.PAYMENT_TYPES.find(t => t.id === id);
    return type ? type.name : '';
  },
  getPaymentStatusName: (id) => {
    const status = Object.values(cobraConstants.PAYMENT_STATUSES).find(t => t.id === id);
    return status ? status.name : '';
  },
}


export default {
  cobraConstants,
  cobraFunctions
}


// WEBPACK FOOTER //
// ./src/cobra/cobra-constants.js